import {forwardRef, useImperativeHandle, useState} from 'react';
import {useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
import {isNull} from 'lodash';
import clsx from 'clsx';
import {isMobile} from 'react-device-detect';
import {agylePref} from '../../../../store/reducers/preferences';
import {OPTION_BUTTONS_DEFAULT_GAP, useSettingsStyles} from '../userProperties';
import {Chip, FormLabel, Stack} from '@mui/material';

const DEFAULT_STATE = {
    defaultNoteFilter: 'all',
};

const ClinicalNotesFilterMode = forwardRef((props, ref) => {
    const classes = useSettingsStyles();
    const {t} = useTranslation();
    const agylePreference = useSelector(agylePref);

    const [mode, setMode] = useState(!isNull(agylePreference?.defaultNoteFilter) ? agylePreference?.defaultNoteFilter : DEFAULT_STATE.defaultNoteFilter);

    // Return default state of a component
    useImperativeHandle(ref, () => ({
        defaultState: () => {
            setMode(DEFAULT_STATE.defaultNoteFilter);
            return DEFAULT_STATE;
        },
    }));

    const handleChange = (val) => {
        setMode(val);
        props.onChange('defaultNoteFilter', val);
    };

    return (
        <div>
            <FormLabel>
                {t('Select the default filter for clinical notes')}
            </FormLabel>

            <Stack direction='row' gap={OPTION_BUTTONS_DEFAULT_GAP} sx={{mt: 1, my: .5}}>
                <Chip disabled={isMobile} label="All notes" className={clsx(mode === 'all' && classes.activeChip)} onClick={handleChange.bind(this, 'all')} />

                <Chip disabled={isMobile} label="Forms notes" className={clsx(mode === 'system' && classes.activeChip)} onClick={handleChange.bind(this, 'system')} />

                <Chip disabled={isMobile} label="Users notes" className={clsx(mode === 'user' && classes.activeChip)} onClick={handleChange.bind(this, 'user')} />
            </Stack>
        </div>
    );
});

export default ClinicalNotesFilterMode;